import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  Card,
  CardContent,
  TextField,
  Divider,
  Typography,
  Checkbox,
  Button,
  Input,
  Backdrop,
  CircularProgress,
  Select,
  MenuItem,
  FormControlLabel,
  Tooltip,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import { useLocation, useNavigate } from "react-router-dom";
import api, { baseURL } from "../services/api";
import { toast } from "react-toastify";

import { districtLists, emailRegex, SubjectCodes } from "../utils";
import { userInfo } from "../utils/auth";

function EditPersonlDetails() {
  const navigate = useNavigate();
  const location = useLocation();
  // const stateDetails = location.state?.details;
  const stateChecking = location.state?.details;
  const isEdit = location.state?.edit;
  const [stateDetails, setStateDetails] = useState({});
  const [paymentModal, setPaymentModal] = useState(false);

  useEffect(() => {
    if (stateChecking) {
      let cleanedStateDetails = Object.fromEntries(
        Object.entries(stateChecking).map(([key, value]) => [
          key,
          value === "NaN" ? "" : value,
        ])
      );
      // cleanedStateDetails?.adh11 = cleanedStateDetails?.adh11=='00'? '': cleanedStateDetails?.adh11
      setStateDetails(cleanedStateDetails);
    }
  }, [stateChecking]);

  console.log(stateDetails, "stateDetails");
  const [photo, setPhoto] = useState(null);
  const [photoBlob, setPhotoBlob] = useState(null);
  const [signatureBlob, setSignatureBlob] = useState(null);
  const [number, setNumber] = useState("");
  const [sch, setSch] = useState(userInfo()?.school_details?.schoolCode);
  const [emailId, setEMailId] = useState("");
  const [aadharCard, setAadarCard] = useState("");
  const [meritailStatus, setMeritailStatus] = useState("");
  const [studentCategory, setStudentCategory] = useState("");
  const [adderss, setAddress] = useState("");
  const [district, setDistrict] = useState("");
  const [townCity, setTownCity] = useState("");
  const [Pincode, setPinCode] = useState("");
  const [uniqid, setUniqid] = useState("");
  const [dob, setDob] = useState("");

  const [rollCode, setRollCode] = useState("");
  const [rollNo, setRollNo] = useState("");
  const [prevYear, setPrevYear] = useState("");
  const [VisuallyImpared, setVisuallyImpared] = useState("");

  const [medium, setMedium] = useState("");
  const [signature, setSignature] = useState(null);
  const [loader, setLoader] = useState(false);
  const [details, setDetails] = useState({});
  const [religion, setReligion] = useState("");
  const [region, setRegion] = useState("");
  const [visuallyAbled, setVisuallyAbled] = useState("No");
  const [selectedSubjects, setSelectedSubjects] = useState([]);

  useEffect(() => {
    if (stateDetails?.id) {
      if (stateDetails?.dob) {
        setDob(stateDetails?.dob);
      }
    }
  }, [stateDetails]);

  const uploadImageAPi = async (type, file) => {
    setLoader(true);
    const formData = new FormData();
    formData.append("type", type);
    formData.append("file", file);
    try {
      const response = await api.post("compartment/upload-image", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      if (response?.data?.success) {
        toast.success(response?.data?.message);
        setDetails({ ...details, [type]: response?.data?.data });
      } else {
        toast.error(response?.data?.message);
      }
    } catch (error) {
      toast.error(
        error?.response?.data?.message &&
          typeof error?.response?.data?.message === "string"
          ? error?.response?.data?.message
          : "File upload failed. Please try again."
      );
    } finally {
      setLoader(false);
    }
  };

  const handlePhotoChange = (event) => {
    const file = event.target.files[0];

    if (!file) return;

    const fileSizeKB = file.size / 1024; // Convert bytes to KB
    const fileType = file.type.toLowerCase();

    // ✅ Check file format (JPG/JPEG only)
    if (!(fileType === "image/jpeg" || fileType === "image/jpg")) {
      toast.error("Only JPG/JPEG format is allowed.");
      event.target.value = null;
      return;
    }

    // ✅ Check file size (between 50 KB and 100 KB)
    if (fileSizeKB < 50 || fileSizeKB > 100) {
      toast.error("Photo size must be between 50 KB and 100 KB.");
      event.target.value = null;
      return;
    }

    // ✅ Check image dimensions (35mm × 30mm)
    const img = new Image();
    img.src = URL.createObjectURL(file);
    img.onload = function () {
      const mmToPx = 3.7795275591; // Approximate conversion for 1mm ≈ 3.78 pixels
      const expectedWidth = 35 * mmToPx; // Convert 35mm to pixels
      const expectedHeight = 30 * mmToPx; // Convert 30mm to pixels

      // if (
      //   Math.abs(img.width - expectedWidth) > 5 || // Allow slight tolerance
      //   Math.abs(img.height - expectedHeight) > 5
      // ) {
      //   toast.error("Photo dimensions must be 35mm × 30mm.");
      //   event.target.value = null;
      //   return;
      // }

      // ✅ Set the image if all validations pass
      setPhoto(URL.createObjectURL(file));
      setPhotoBlob(file);
    };
  };

  const handleSignatureChange = (event) => {
    const file = event.target.files[0];

    if (!file) return;

    const fileSizeKB = file.size / 1024; // Convert bytes to KB
    const fileType = file.type.toLowerCase();

    // ✅ Allow only JPG/JPEG formats
    if (!(fileType === "image/jpeg" || fileType === "image/jpg")) {
      toast.error("Only JPG/JPEG format is allowed for the signature.");
      event.target.value = null;
      return;
    }

    // ✅ Ensure file size is between 5 KB and 20 KB
    if (fileSizeKB < 5 || fileSizeKB > 20) {
      toast.error("Signature size must be between 5 KB and 20 KB.");
      event.target.value = null;
      return;
    }

    // ✅ Check image dimensions (3.5 cm × 1 cm)
    const img = new Image();
    img.src = URL.createObjectURL(file);
    img.onload = function () {
      const mmToPx = 3.7795275591; // Approximate conversion (1mm ≈ 3.78 pixels)
      const expectedWidth = 3.5 * 10 * mmToPx; // Convert 3.5 cm to pixels
      const expectedHeight = 1 * 10 * mmToPx; // Convert 1 cm to pixels

      // if (
      //   Math.abs(img.width - expectedWidth) > 5 || // Allow slight tolerance
      //   Math.abs(img.height - expectedHeight) > 5
      // ) {
      //   toast.error("Signature dimensions must be 3.5 cm × 1 cm.");
      //   event.target.value = null;
      //   return;
      // }

      // ✅ Set the signature if all validations pass
      setSignature(URL.createObjectURL(file));
      setSignatureBlob(file);
    };
  };

  const handlePublichPhoto = (type) => {
    if (type === "signature") {
      uploadImageAPi(type, signatureBlob);
    } else {
      uploadImageAPi(type, photoBlob);
    }
  };

  const fileInputRef = useRef(null); // Create a reference for file input
  const fileInputSignatureRef = useRef(null); // Create a reference for file input

  const [checked, setChecked] = useState(false);
  const [declarationChecked, setDeclarationChecked] = useState(false);

  const handleCheckboxChange = (event) => {
    setChecked(event.target.checked);
  };

  const [isPreviewOPen, setIsPreview] = useState(false);

  // const handlePreview = () => {
  //   if (uniqid && uniqid?.toString()?.length < 5) {
  //     toast.error(
  //       "BSEB Unique ID should be at least 5 characters if you have, if not please leave it blank"
  //     );
  //     return;
  //   }

  //   if (!number && !stateDetails?.mobile) {
  //     toast.error("Please Enter Mobile Number ");
  //     return;
  //   }
  //   if (number && number?.toString()?.length !== 10) {
  //     toast.error("Please Enter Proper Mobile Number ");
  //     return;
  //   }
  //   if (!emailId && !stateDetails?.email) {
  //     toast.error("Please Enter Email Address ");
  //     return;
  //   }

  //   if (emailId && !emailRegex.test(emailId)) {
  //     toast.error("Please Enter Proper Email Address ");
  //     return;
  //   }
  //   if (!aadharCard && !stateDetails?.adh11 && !declarationChecked) {
  //     toast.error("Please Enter Aadhar Number or Check Declaration ");
  //     return;
  //   }

  //   if (
  //     aadharCard?.toString()?.length !== 12 &&
  //     stateDetails?.adh11?.toString()?.length !== 12 &&
  //     !declarationChecked
  //   ) {
  //     toast.error("Please Enter Proper Aadhar Number or Check Declaration ");
  //     return;
  //   }
  //   if (!region && !stateDetails?.region) {
  //     toast.error("Please select Area ");
  //     return;
  //   }
  //   if (!religion && !stateDetails?.religion) {
  //     toast.error("Please select Religion ");
  //     return;
  //   }
  //   if (!meritailStatus && !stateDetails?.merit) {
  //     toast.error("Please select Marital Status ");
  //     return;
  //   }
  //   if (!medium && !stateDetails?.md) {
  //     toast.error("Please select Medium of Exam ");
  //     return;
  //   }
  //   if (!adderss && !stateDetails?.adderss) {
  //     toast.error("Please Enter Address ");
  //     return;
  //   }
  //   if (!townCity && !stateDetails?.town) {
  //     toast.error("Please Enter Town / City Name ");
  //     return;
  //   }
  //   if (!Pincode && !stateDetails?.pcrtno) {
  //     toast.error("Please Enter Pincode ");
  //     return;
  //   }

  //   if (!studentCategory && !stateDetails?.applycat) {
  //     toast.error("Please select Student Category ");
  //     return;
  //   }
  //   if (
  //     studentCategory === "C" ||
  //     studentCategory === "E" ||
  //     studentCategory === "B" ||
  //     studentCategory === "Single Subject (English)" ||
  //     stateDetails?.applycat === "C" ||
  //     stateDetails?.applycat === "E" ||
  //     stateDetails?.applycat === "B" ||
  //     stateDetails?.applycat === "Single Subject (English)"
  //   ) {
  //     // if (!rollCode && !stateDetails?.ex_rollcd) {
  //     //   toast.error("Please enter Roll Code ");
  //     //   return;
  //     // }
  //     // if (!rollNo && !stateDetails?.ex_rollno) {
  //     //   toast.error("Please enter Roll Number ");
  //     //   return;
  //     // }
  //     // if (!prevYear && !stateDetails?.ex_yr_exam) {
  //     //   toast.error("Please enter Previous Exam Year ");
  //     //   return;
  //     // }
  //   }
  //   if (selectedSubjects.length == 0) {
  //     toast.error("Please select Subjects ");
  //     return;
  //   }
  //   setIsPreview(true);
  // };

  const handleApplyClick = async (e) => {
    let updateFields = {
      regNo: stateDetails?.o_reg,
    };

    if (stateDetails?.dob !== dob && dob) {
      updateFields.dob = dob;
    }
    if (uniqid && uniqid !== stateDetails?.uniqid) {
      updateFields.uniqid = uniqid;
    }
    if (number && number !== stateDetails?.mobile) {
      updateFields.mobile = number;
    }
    if (emailId && emailId !== stateDetails?.email) {
      updateFields.email = emailId;
    }
    if (aadharCard && aadharCard !== stateDetails?.adh11) {
      updateFields.adh11 = aadharCard;
    }
    if (sch && sch !== stateDetails?.sch) {
      updateFields.sch = sch;
    }
    if (rollNo && rollNo !== stateDetails?.ex_rollno) {
      updateFields.ex_rollno = rollNo;
    }
    if (prevYear && prevYear !== stateDetails?.ex_yr_exam) {
      updateFields.ex_yr_exam = prevYear;
    }
    // if (uniqid && uniqid !== stateDetails?.uniqid) {
    //   updateFields.uniqid = uniqid;
    // }
    // if (region && region !== stateDetails?.region) {
    //   updateFields.region = region;
    // }
    // if (religion && religion !== stateDetails?.religion) {
    //   updateFields.religion = religion;
    // }
    // if (meritailStatus && meritailStatus !== stateDetails?.merit) {
    //   updateFields.merit = meritailStatus;
    // }
    // if (medium && medium !== stateDetails?.md) {
    //   updateFields.md = medium;
    // }
    // if (adderss && adderss !== stateDetails?.adderss) {
    //   updateFields.adderss = adderss;
    // }
    // if (townCity && townCity !== stateDetails?.town) {
    //   updateFields.town = townCity;
    // }
    // if (Pincode && Pincode !== stateDetails?.pcrtno) {
    //   updateFields.pcrtno = Pincode;
    // }
    // if (VisuallyImpared && VisuallyImpared !== stateDetails?.VisuallyImpared) {
    //   updateFields.VisuallyImpared = VisuallyImpared;
    // }
    if (selectedSubjects?.length) {
      updateFields.selectedSubjects = [...selectedSubjects];
    }
    // if (
    //   studentCategory === "C" ||
    //   studentCategory === "E" ||
    //   studentCategory === "B" ||
    //   studentCategory === "Single Subject (English)" ||
    //   stateDetails?.applycat === "C" ||
    //   stateDetails?.applycat === "E" ||
    //   stateDetails?.applycat === "B" ||
    //   stateDetails?.applycat === "Single Subject (English)"
    // ) {
    //   if (rollCode && rollCode !== stateDetails?.ex_rollcd) {
    //     updateFields.ex_rollcd = rollCode;
    //   }
    //   if (rollNo && rollNo !== stateDetails?.ex_rollno) {
    //     updateFields.ex_rollno = rollNo;
    //   }
    //   if (prevYear && prevYear !== stateDetails?.ex_yr_exam) {
    //     updateFields.ex_yr_exam = prevYear;
    //   }
    // }

    e.preventDefault();
    setLoader(true);
    try {
      const response = await api.patch("compartment/edit", {
        // photograph_path: UserDetails?.photograph,
        // signature_path: UserDetails?.signature,
        // compartment_id: stateDetails?.id,
        ...updateFields,
      });
      console.log(response, "response");
      if (response?.data?.message === "Compartment data updated successfully") {
        toast.success(response?.data?.message);
        navigate("/edit-user");
      } else {
        toast.error(response?.data?.message);
      }
    } catch (error) {
      toast.error(
        error?.response?.data?.message ?? "Error Saving, please try again."
      );
    } finally {
      setLoader(false);
    }
  };
  const handleDeletePhoto = () => {
    setPhoto(null);
    setPhotoBlob(null);
    setDetails({ ...details, photograph: "" });
    if (fileInputRef.current) {
      fileInputRef.current.value = null; // Clear file input
    }
  };

  const handleDeleteSignature = () => {
    setSignature(null);
    setSignatureBlob(null);
    setDetails({ ...details, signature: "" });

    if (fileInputRef.current) {
      fileInputRef.current.value = null; // Clear file input
    }
  };

  const handleSelectedSubjects = (name) => {
    setSelectedSubjects(
      (prev) =>
        prev.includes(name)
          ? prev.filter((item) => item !== name) // Remove if exists
          : [...prev, name] // Add if not exists
    );
  };

  const getSingleSUbjectsList = (student) => {
    if (
      student?.res1 !== "F" &&
      student?.res2 !== "F" &&
      student?.res3 !== "F" &&
      student?.res4 !== "F" &&
      student?.res5 !== "F" &&
      student?.res6 !== "F" &&
      student?.res7 === "F" &&
      student?.res8 !== "F"
    ) {
      return true;
    } else return false;
    // let reqData = resFields.filter((item) => {
    //   // Check if res7 is "F" and all other resX fields are not "F"
    //   return resFields.every((field, index) =>
    //     field === "res7" ? item[field] === "F" : item[field] !== "F"
    //   );
    // });
  };

  const isStudentFail_Absent = () => {
    let eligibleData = [
      "res1",
      "res2",
      "res3",
      "res4",
      "res5",
      "res6",
      "res7",
      "res8",
      "mks1",
      "mks2",
      "mks3",
      "mks4",
      "mks5",
      "mks6",
      "mks7",
      "mks8",
    ];
    let isStudentConditionCheck = false;
    eligibleData?.forEach((item) => {
      if (stateDetails?.[item] == "ABS" || stateDetails?.[item] == "F") {
        isStudentConditionCheck = true;
      }
    });
    return isStudentConditionCheck;
  };

  useEffect(() => {
    if (stateDetails?.id) {
      if (stateDetails?.ex_rollno) {
        setRollNo(stateDetails?.ex_rollno);
      }
      if (stateDetails?.ex_yr_exam) {
        setPrevYear(stateDetails?.ex_yr_exam);
      }
      if (stateDetails?.uniqid) {
        setUniqid(stateDetails?.uniqid);
      }
      if (stateDetails?.dob) {
        setDob(stateDetails?.dob);
      }
      if (stateDetails?.mobile) {
        setNumber(stateDetails?.mobile);
      }
      if (stateDetails?.email) {
        setEMailId(stateDetails?.email);
      }
      if (stateDetails?.VisuallyImpared) {
        setVisuallyImpared(stateDetails?.VisuallyImpared);
      }
      if (stateDetails?.region) {
        setRegion(stateDetails?.region);
      }
      if (stateDetails?.religion) {
        setReligion(stateDetails?.religion);
      }
      if (stateDetails?.merit) {
        setMeritailStatus(stateDetails?.merit);
      }
      if (stateDetails?.md) {
        setMedium(stateDetails?.md);
      }
      if (stateDetails?.applycat) {
        setStudentCategory(stateDetails?.applycat);
      }
      if (stateDetails?.selectedSubjects) {
        setSelectedSubjects(stateDetails?.selectedSubjects);
      }
      if (stateDetails?.adderss) {
        setAddress(stateDetails?.adderss);
      }
      if (stateDetails?.dst) {
        setDistrict(stateDetails?.dst);
      }
      if (stateDetails?.town) {
        setTownCity(stateDetails?.town);
      }
      if (stateDetails?.pcrtno) {
        setPinCode(stateDetails?.pcrtno);
      }
      if (stateDetails?.adh11) {
        setAadarCard(stateDetails?.adh11);
      }
      if (stateDetails?.compartmentFormRequest_data?.photograph_path) {
        setPhoto(
          `${baseURL}${
            stateDetails?.compartmentFormRequest_data?.photograph_path?.startsWith(
              "/"
            )
              ? stateDetails?.compartmentFormRequest_data?.photograph_path?.slice(
                  1
                )
              : stateDetails?.compartmentFormRequest_data?.photograph_path
          }`
        );
      }
      if (stateDetails?.compartmentFormRequest_data?.signature_path) {
        setSignature(
          `${baseURL}${stateDetails?.compartmentFormRequest_data?.signature_path}`
        );
      }
      if (stateDetails?.sch) {
        setSch(stateDetails?.sch);
      }
    }
  }, [stateDetails?.id]);

  return (
    <Box sx={{ flexGrow: 1, p: 2 }}>
      <Grid container spacing={2}>
        {/* Full width Card */}
        <Grid item xs={12}>
          <Card sx={{ border: "2px solid #122e5b" }}>
            {/* Header Section */}
            <Typography
              variant="h6"
              sx={{
                backgroundColor: "#122e5b",
                color: "white",
                padding: "10px",
                fontWeight: "bold",
                textAlign: "center",
              }}
            >
              PERSONAL DETAILS:- [{" "}
              {stateDetails?.status_applied || isEdit
                ? "Applied"
                : "Not Applied"}{" "}
              ]
              <span
                style={{
                  marginLeft: "17px",
                  width: "15px",
                }}
              >
                {stateDetails?.o_reg &&
                stateDetails?.o_reg?.split("-")[2] != "24"
                  ? "Special"
                  : stateDetails?.applycat === "C"
                  ? "Compartment"
                  : getSingleSUbjectsList(stateDetails)
                  ? "Single Subject (English)"
                  : stateDetails?.applycat === "B"
                  ? "Betterment"
                  : "Special"}

                {/* {stateDetails?.fr === "F" ? "Compartment" : "Special"} */}
              </span>
            </Typography>

            <Divider />

            {/* Card Content with 4 Box Grid Layout */}
            <CardContent>
              <Grid container spacing={2}>
                {/* Box 1 */}
                <Grid item size={{ xs: 12, md: 6 }}>
                  <Grid container spacing={1}>
                    <Grid item size={{ sm: 6 }}>
                      <Typography>
                        <b>School Code/Name:</b>
                      </Typography>
                    </Grid>
                    <Grid item size={{ sm: 6 }}>
                      <Typography
                        style={{ color: "green", fontWeight: "bold" }}
                      >
                        {/* {userInfo()?.school_details?.schoolCode} */}
                        <TextField
                          fullWidth
                          size="small"
                          value={sch}
                          placeholder="Please enter School code"
                          onChange={(e) => setSch(e.target.value)}
                        />
                        /{userInfo()?.school_details?.name}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item size={{ xs: 12, md: 6 }}>
                  <Grid container spacing={1}>
                    <Grid item size={{ sm: 6 }}>
                      <Typography>
                        <b>Registration No:</b>
                      </Typography>
                    </Grid>
                    <Grid item size={{ sm: 6 }}>
                      <Typography>
                        {stateDetails?.o_reg ? stateDetails?.o_reg : "_"}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item size={{ xs: 12, md: 6 }}>
                  <Grid container spacing={1}>
                    <Grid item size={{ sm: 6 }}>
                      <Typography>
                        {!stateDetails?.uniqid && (
                          <b style={{ color: "red" }}>* </b>
                        )}

                        <b>BSEB Unique ID:</b>
                      </Typography>
                    </Grid>
                    <Grid item size={{ sm: 6 }}>
                      {stateDetails?.uniqid ? (
                        <Typography>{stateDetails?.uniqid}</Typography>
                      ) : (
                        <TextField
                          fullWidth
                          size="small"
                          value={
                            !stateDetails?.uniqid
                              ? uniqid
                              : stateDetails?.uniqid
                              ? stateDetails?.uniqid
                              : uniqid
                          }
                          disabled={stateDetails?.uniqid}
                          placeholder="Please enter BSEB Unique ID:"
                          onChange={(e) => setUniqid(e.target.value)}
                          inputProps={{
                            inputMode: "numeric",
                            pattern: "[0-12]*",
                          }} // Ensures only numeric input
                          onInput={(e) => {
                            e.target.value = e.target.value.replace(/\D/g, ""); // Removes non-numeric characters
                          }}
                        />
                      )}
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item size={{ xs: 12, md: 6 }}>
                  <Grid container spacing={1}>
                    <Grid item size={{ sm: 6 }}>
                      <Typography>
                        <b>Mother's Name:</b>
                      </Typography>
                    </Grid>
                    <Grid item size={{ sm: 6 }}>
                      <Typography>
                        {stateDetails?.mnm ? stateDetails?.mnm : "_"}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item size={{ xs: 12, md: 6 }}>
                  <Grid container spacing={1}>
                    <Grid item size={{ sm: 6 }}>
                      <Typography>
                        <b>Student's Name:</b>
                      </Typography>
                    </Grid>
                    <Grid item size={{ sm: 6 }}>
                      <Typography style={{ fontWeight: "bold" }}>
                        {stateDetails?.nm ? stateDetails?.nm : "_"}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item size={{ xs: 12, md: 6 }}>
                  <Grid container spacing={1}>
                    <Grid item size={{ sm: 6 }}>
                      <Typography>
                        <b>Date of Birth:</b>
                      </Typography>
                    </Grid>
                    <Grid item size={{ sm: 6 }}>
                      <Typography>
                        {/* {stateDetails?.dob ? stateDetails?.dob : "_"} */}
                        <TextField
                          fullWidth
                          size="small"
                          value={dob}
                          placeholder="Please enter mobile number"
                          onChange={(e) => setDob(e.target.value)}
                          // stateDetails?.adh11?.toString()?.length == 12

                          inputProps={{
                            inputMode: "numeric",
                            pattern: "[0-9]*",
                          }} // Ensures only numeric input
                          onInput={(e) => {
                            e.target.value = e.target.value.replace(/\D/g, ""); // Removes non-numeric characters
                          }}
                        />
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item size={{ xs: 12, md: 6 }}>
                  <Grid container spacing={1}>
                    <Grid item size={{ sm: 6 }}>
                      <Typography>
                        <b>Father's Name:</b>
                      </Typography>
                    </Grid>
                    <Grid item size={{ sm: 6 }}>
                      <Typography>
                        {stateDetails?.fnm ? stateDetails?.fnm : "_"}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item size={{ xs: 12, md: 6 }}>
                  <Grid container spacing={1}>
                    <Grid item size={{ sm: 6 }}>
                      <Typography>
                        <b>Caste Category:</b>
                      </Typography>
                    </Grid>
                    <Grid item size={{ sm: 6 }}>
                      <Typography>
                        {stateDetails?.caste ? stateDetails?.caste : "_"}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item size={{ xs: 12, md: 6 }}>
                  <Grid container spacing={1}>
                    <Grid item size={{ sm: 6 }}>
                      <Typography>
                        <b>sex:</b>
                      </Typography>
                    </Grid>
                    <Grid item size={{ sm: 6 }}>
                      <Typography>
                        {stateDetails?.sex ? stateDetails?.sex : "_"}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item size={{ xs: 12, md: 6 }}>
                  <Grid container spacing={1}>
                    <Grid item size={{ sm: 6, xs: 12 }}>
                      <Typography>
                        <b style={{ color: "red" }}>* </b>
                        <b>Mobile No.:</b>
                      </Typography>
                    </Grid>
                    <Grid item size={{ sm: 6, xs: 12 }}>
                      <TextField
                        fullWidth
                        size="small"
                        value={number}
                        placeholder="Please enter mobile number"
                        onChange={(e) => setNumber(e.target.value)}
                        // stateDetails?.adh11?.toString()?.length == 12

                        inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }} // Ensures only numeric input
                        onInput={(e) => {
                          e.target.value = e.target.value.replace(/\D/g, ""); // Removes non-numeric characters
                        }}
                      />
                    </Grid>
                  </Grid>
                </Grid>

                {/* <Grid item size={{ xs: 12, md: 6 }}>
                  <Grid container spacing={1}>
                    <Grid item size={{ sm: 6, xs: 12 }}>
                      <Typography sx={{ fontWeight: "bold", mt: 1 }}>
                        <b style={{ color: "red" }}>*</b>Differently abled:

                      </Typography>
                    </Grid>
                    <Grid item size={{ sm: 6, xs: 12 }}>
                      <TextField fullWidth size="small" value="No" />
                    </Grid>
                  </Grid>
                </Grid> */}

                <Grid item size={{ xs: 12, md: 6 }}>
                  <Grid container spacing={1}>
                    <Grid item size={{ sm: 6 }}>
                      <Typography>
                        <b> Differently abled:</b>
                      </Typography>
                    </Grid>
                    <Grid item size={{ sm: 6 }}>
                      <Typography>
                        {stateDetails?.ph ? stateDetails?.ph : "_"}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid
                  item
                  size={{ xs: 12, md: 6 }}
                  style={{ paddingBottom: "12px" }}
                >
                  <Grid container spacing={1}>
                    <Grid item size={{ sm: 6, xs: 12 }}>
                      <Typography>
                        <b style={{ color: "red" }}>* </b>

                        <b>Email Address:</b>
                      </Typography>
                    </Grid>
                    <Grid item size={{ sm: 6, xs: 12 }}>
                      <TextField
                        fullWidth
                        size="small"
                        value={emailId}
                        placeholder="Please enter email Id"
                        onChange={(e) => setEMailId(e.target.value)}
                      />
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item size={{ xs: 12, md: 6 }}>
                  <Grid
                    container
                    spacing={1}
                    style={{
                      marginBottom: "15px",
                    }}
                  >
                    <Grid item size={{ sm: 6, xs: 12 }}>
                      <Typography variant="body2" fontWeight="bold">
                        Visually impaired:
                      </Typography>
                    </Grid>
                    {/* <Grid item size={{ sm: 6 }}>
                      <Typography>
                        {stateDetails?.VisuallyImpared
                          ? stateDetails?.VisuallyImpared
                          : "_"}
                      </Typography>
                    </Grid> */}

                    <Grid item size={{ sm: 6, xs: 12 }}>
                      <Select
                        value={VisuallyImpared}
                        onChange={(e) => {
                          setVisuallyImpared(e.target.value);
                        }}
                        // width
                        fullWidth
                        // defaultValue="Special"
                        className="card-title"
                        sx={{
                          height: 36, // Adjust the height
                          "& .MuiSelect-select": {
                            padding: "8px", // Adjust inner padding
                            minHeight: "unset", // Override MUI's default min-height
                          },
                        }}
                      >
                        <MenuItem value="Yes">Yes</MenuItem>
                        <MenuItem value="No">No</MenuItem>
                      </Select>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
              <Box
                sx={{
                  borderTop: "2px solid #ccc",
                  borderBottom: "2px solid #ccc",
                  paddingTop: 2,
                  paddingBottom: 2,
                }}
              >
                <Grid container spacing={2} alignItems="flex-start">
                  {/* Left Side Text */}
                  <Grid
                    item
                    size={{ xs: 12, md: 8 }}
                    sx={{ borderRight: "2px solid #ccc", paddingRight: 2 }}
                  >
                    <Typography
                      variant="subtitle2"
                      sx={{
                        color: "red",
                        fontWeight: "bold",
                        textDecoration: "underline",
                      }}
                      className="card-title"
                    >
                      # PLEASE MENTION "AADHAR NUMBER" / कृपया "आधार नंबर" अंकित
                      करें:
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{ fontSize: "0.9rem", marginTop: 1 }}
                      className="card-title"
                    >
                      (If candidate has not enrolled in Aadhar and doesn't have
                      "Aadhar number", then he/she is required to submit
                      declaration in below column that he/she has not been
                      enrolled in Aadhar and has not got "Aadhar number".) /
                      (यदि आवेदक को "आधार नंबर" आवंटित नहीं हुआ है, तो आवेदक को
                      यह घोषणा नीचे के कॉलम में करनी होगी कि "आधार नंबर" आवंटित
                      नहीं हुआ है।)
                    </Typography>
                  </Grid>

                  {/* Right Side Input Field */}
                  <Grid item size={{ xs: 12, md: 4 }}>
                    <TextField
                      label="Aadhar Number"
                      placeholder="e.g., 999999999999"
                      variant="outlined"
                      fullWidth
                      value={aadharCard}
                      sx={{ marginBottom: 1 }}
                      onChange={(e) => setAadarCard(e.target.value)}
                      //   disabled={
                      //     declarationChecked ||
                      //     (stateDetails?.adh11 &&
                      //       stateDetails?.adh11?.toString()?.length == 12)
                      //   }
                      inputProps={{ inputMode: "numeric", pattern: "[0-12]*" }} // Ensures only numeric input
                      onInput={(e) => {
                        e.target.value = e.target.value.replace(/\D/g, ""); // Removes non-numeric characters
                      }}
                    />
                    <Typography
                      variant="caption"
                      sx={{
                        display: "block",
                        color: "gray",
                        textAlign: "right",
                      }}
                    >
                      e.g., 999999999999
                    </Typography>
                  </Grid>
                </Grid>
              </Box>
              <Box
                sx={{
                  paddingTop: 2,
                }}
              >
                {/* Instruction Text */}
                <Typography
                  variant="body2"
                  sx={{ color: "red", fontSize: "0.9rem", mb: 1 }}
                  className="card-title"
                >
                  If candidate has not given "Aadhar number" in above column,
                  then following declaration should be given by candidate / यदि
                  आवेदक द्वारा उपरोक्त कॉलम में "आधार नंबर" अंकित नहीं किया गया
                  है, तो उनके द्वारा निम्नलिखित घोषणा दी जाएगी।
                </Typography>
                <Typography
                  variant="body2"
                  sx={{ color: "red", fontSize: "0.9rem", mb: 2 }}
                  className="card-title"
                >
                  (Please note that any WRONG DECLARATION made here, may invite
                  action against the candidate and his/her candidature may be
                  cancelled due to making false declaration about non-allotment
                  of "Aadhar number" / कृपया ध्यान दें कि यहाँ की गई किसी भी गलत
                  घोषणा के लिए आवेदक के विरुद्ध कार्रवाई की जा सकती है तथा आधार
                  नंबर नहीं होने के संबंध में इस झूठी/गलत घोषणा के कारण उनका
                  अभ्यर्थिता रद्द किया जा सकता है।)
                </Typography>

                {/* Declaration Text with Checkbox */}
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "flex-start",
                    gap: 2,
                    "@media (max-width: 520px)": {
                      flexDirection: "column", // Change to column when width is 520px or less
                    },
                  }}
                >
                  <Checkbox
                    checked={declarationChecked}
                    onChange={(e) => {
                      setDeclarationChecked(e.target.checked);
                      setAadarCard("");
                    }}
                    color="primary"
                  />
                  <Typography
                    variant="body2"
                    sx={{
                      fontSize: "0.9rem",
                      lineHeight: 1.5,
                      fontWeight: 600,
                      textDecoration: "underline",
                    }}
                    className="card-title"
                  >
                    <strong sx={{ fontSize: "1rem", lineHeight: 1.5 }}>
                      DECLARATION / घोषणा:
                    </strong>{" "}
                    I, hereby declare that I have not enrolled in Aadhar and
                    have not got any "Aadhar number". I also understand that any
                    false declaration made by me in this regard may have
                    consequence of cancellation of my candidature / मैं, एतद
                    द्वारा पुष्टि करता हूं कि मैंने "आधार नंबर" आवंटित करने के
                    लिए आवेदन नहीं किया। तथा मुझे "आधार नंबर" आवंटित नहीं हुआ।
                    मैं यह भी समझता हूं कि मेरे द्वारा की गई झूठी/गलत घोषणा के
                    आधार पर मेरा अभ्यर्थिता रद्द किया जा सकता है।
                  </Typography>
                </Box>
              </Box>

              <Box
                sx={{
                  borderTop: "2px solid #ccc",
                  paddingTop: 2,
                  margin: "20px auto",
                }}
              >
                {/* First Row */}
                <Grid container spacing={2}>
                  {/* Column 1: Labels */}

                  <Grid item size={{ xs: 12, md: 6 }}>
                    <Grid container spacing={1}>
                      <Grid item size={{ sm: 6, xs: 12 }}>
                        <Typography variant="body2" fontWeight="bold">
                          <b style={{ color: "red" }}>* </b>Area:
                        </Typography>
                      </Grid>
                      <Grid item size={{ sm: 6, xs: 12 }}>
                        <Select
                          value={region}
                          onChange={(e) => {
                            setRegion(e.target.value);
                          }}
                          // width
                          fullWidth
                          // defaultValue="Special"
                          className="card-title"
                          sx={{
                            height: 36, // Adjust the height
                            "& .MuiSelect-select": {
                              padding: "8px", // Adjust inner padding
                              minHeight: "unset", // Override MUI's default min-height
                            },
                          }}
                        >
                          <MenuItem value="Rural">Rural</MenuItem>
                          <MenuItem value="Urban">Urban</MenuItem>
                        </Select>
                      </Grid>
                    </Grid>
                  </Grid>

                  <Grid item size={{ xs: 12, md: 6 }}>
                    <Grid container spacing={1}>
                      <Grid item size={{ sm: 6, xs: 12 }}>
                        <Typography variant="body2" fontWeight="bold">
                          <b style={{ color: "red" }}>* </b>Nationality:
                        </Typography>
                      </Grid>
                      <Grid item size={{ sm: 6, xs: 12 }}>
                        {/* <Select
                          value={"Inidan"}
                          // onChange={(e) => {
                          //   setRegion(e.target.value);
                          // }}
                          // width
                          fullWidth
                          // defaultValue="Special"
                          className="card-title"
                          sx={{
                            height: 36, // Adjust the height
                            "& .MuiSelect-select": {
                              padding: "8px", // Adjust inner padding
                              minHeight: "unset", // Override MUI's default min-height
                            },
                          }}
                        >
                          <MenuItem value="Inidan">Inidan</MenuItem>
                        </Select> */}

                        <TextField
                          disabled
                          size="small"
                          fullWidth
                          defaultValue={
                            stateDetails?.national
                              ? stateDetails?.national == "I"
                                ? "Indian"
                                : stateDetails?.national
                              : "Indian"
                          }
                        />
                      </Grid>
                    </Grid>
                  </Grid>

                  <Grid item size={{ xs: 12, md: 6 }}>
                    <Grid container spacing={1}>
                      <Grid item size={{ sm: 6, xs: 12 }}>
                        <Typography variant="body2" fontWeight="bold">
                          <b style={{ color: "red" }}>* </b>Religion:
                        </Typography>
                      </Grid>

                      <Grid item size={{ sm: 6, xs: 12 }}>
                        <Select
                          // value={religion}
                          value={religion}
                          defaultValue={religion}
                          onChange={(e) => {
                            setReligion(e.target.value);
                          }}
                          // disabled={stateDetails?.religion}
                          // width
                          fullWidth
                          // defaultValue="Special"
                          className="card-title"
                          sx={{
                            height: 36, // Adjust the height
                            "& .MuiSelect-select": {
                              padding: "8px", // Adjust inner padding
                              minHeight: "unset", // Override MUI's default min-height
                            },
                          }}
                        >
                          <MenuItem value="H">Hinduism</MenuItem>
                          <MenuItem value="I">Islam</MenuItem>
                          <MenuItem value="C">Christianity</MenuItem>
                          <MenuItem value="S">Sikhism</MenuItem>
                          <MenuItem value="B">Buddhism</MenuItem>
                          <MenuItem value="J">Jainism</MenuItem>
                        </Select>
                      </Grid>
                    </Grid>
                  </Grid>

                  <Grid item size={{ xs: 12, md: 6 }}>
                    <Grid container spacing={1}>
                      <Grid item size={{ sm: 6, xs: 12 }}>
                        <Typography variant="body2" fontWeight="bold">
                          <b style={{ color: "red" }}>* </b>Marital Status:
                        </Typography>
                      </Grid>
                      <Grid item size={{ sm: 6, xs: 12 }}>
                        {/* <TextField
                          size="small"
                          fullWidth
                          defaultValue="Unmarried"
                        /> */}
                        <Select
                          value={meritailStatus}
                          //   disabled={stateDetails?.merit}
                          onChange={(e) => {
                            setMeritailStatus(e.target.value);
                          }}
                          // width
                          fullWidth
                          // defaultValue="Special"
                          className="card-title"
                          sx={{
                            height: 36, // Adjust the height
                            "& .MuiSelect-select": {
                              padding: "8px", // Adjust inner padding
                              minHeight: "unset", // Override MUI's default min-height
                            },
                          }}
                        >
                          <MenuItem value="Married">Married</MenuItem>
                          <MenuItem value="Un-Married">Un-Married</MenuItem>
                        </Select>
                      </Grid>
                    </Grid>
                  </Grid>

                  <Grid item size={{ xs: 12, md: 6 }}>
                    <Grid container spacing={1}>
                      <Grid item size={{ sm: 6, xs: 12 }}>
                        <Typography
                          variant="body2"
                          fontWeight="bold"
                          sx={{ mb: 3 }}
                        >
                          <b style={{ color: "red" }}>* </b>Medium of Exam:
                        </Typography>
                      </Grid>
                      <Grid item size={{ sm: 6, xs: 12 }}>
                        <Select
                          // value={medium}
                          value={
                            medium
                              ? medium === "H"
                                ? "Hindi"
                                : "English"
                              : medium
                          }
                          //   disabled={stateDetails?.md}
                          onChange={(e) => {
                            setMedium(e.target.value);
                          }}
                          // width
                          fullWidth
                          // defaultValue="Special"
                          className="card-title"
                          sx={{
                            height: 36, // Adjust the height
                            "& .MuiSelect-select": {
                              padding: "8px", // Adjust inner padding
                              minHeight: "unset", // Override MUI's default min-height
                            },
                          }}
                        >
                          <MenuItem value="Hindi">Hindi</MenuItem>
                          <MenuItem value="English">English</MenuItem>
                        </Select>
                      </Grid>
                    </Grid>
                  </Grid>

                  <Grid item size={{ xs: 12, md: 6 }}>
                    <Grid container spacing={1}>
                      <Grid item size={{ sm: 6, xs: 12 }}>
                        <Typography variant="body2" fontWeight="bold">
                          <b style={{ color: "red" }}>* </b>Student Category:
                        </Typography>
                      </Grid>
                      <Grid item size={{ sm: 6, xs: 12 }}>
                        <Select
                          // value={studentCategory}
                          value={
                            stateDetails?.applycat === "E"
                              ? stateDetails?.o_reg &&
                                stateDetails?.o_reg?.split("-")[2] != "24"
                                ? "E"
                                : getSingleSUbjectsList(stateDetails)
                                ? "Single Subject (English)"
                                : "R"
                              : stateDetails?.applycat
                              ? stateDetails?.applycat
                              : studentCategory
                          }
                          disabled={stateDetails?.applycat}
                          onChange={(e) => {
                            setStudentCategory(e.target.value);
                          }}
                          // width
                          fullWidth
                          // defaultValue="Special"
                          className="card-title"
                          sx={{
                            height: 36, // Adjust the height
                            "& .MuiSelect-select": {
                              padding: "8px", // Adjust inner padding
                              minHeight: "unset", // Override MUI's default min-height
                            },
                          }}
                        >
                          <MenuItem value="R"> Reg/Pvt</MenuItem>
                          {/* <MenuItem value="Ex-Private">Ex-Private</MenuItem> */}
                          <MenuItem value="C">Compartment</MenuItem>
                          <MenuItem value="E">Ex-Student</MenuItem>
                          <MenuItem value="B">Betterment</MenuItem>
                          <MenuItem value="Single Subject (English)">
                            Single Subject (English)
                          </MenuItem>
                          <MenuItem value="Opt. Prac">Opt. Prac</MenuItem>
                        </Select>
                      </Grid>
                    </Grid>
                  </Grid>
                  {true && (
                    <>
                      <Grid item size={{ xs: 12, md: 6 }}>
                        <Grid container spacing={1}>
                          <Grid item size={{ sm: 6, xs: 12 }}>
                            <Typography variant="body2" fontWeight="bold">
                              <b style={{ color: "red" }}>* </b>Roll Code:
                            </Typography>
                          </Grid>
                          <Grid item size={{ sm: 6, xs: 12 }}>
                            <TextField
                              fullWidth
                              size="small"
                              value={sch}
                              disabled={sch}
                              placeholder="Please enter Roll Code"
                              // onChange={(e) => setRollCode(e.target.value)}
                            />
                          </Grid>
                        </Grid>
                      </Grid>
                      <Grid item size={{ xs: 12, md: 6 }}>
                        <Grid container spacing={1}>
                          <Grid item size={{ sm: 6, xs: 12 }}>
                            <Typography variant="body2" fontWeight="bold">
                              {/* <b style={{ color: "red" }}>* </b> */}
                              Roll No:
                            </Typography>
                          </Grid>
                          <Grid item size={{ sm: 6, xs: 12 }}>
                            <TextField
                              fullWidth
                              size="small"
                              // value={
                              //   stateDetails?.ex_rollno
                              //     ? stateDetails?.ex_rollno
                              //     : rollNo
                              // }
                              value={rollNo}
                              // disabled={stateDetails?.ex_rollno}
                              placeholder="Please enter Roll No"
                              onChange={(e) => setRollNo(e.target.value)}
                            />
                          </Grid>
                        </Grid>
                      </Grid>{" "}
                      <Grid item size={{ xs: 12, md: 6 }}>
                        <Grid container spacing={1}>
                          <Grid item size={{ sm: 6, xs: 12 }}>
                            <Typography variant="body2" fontWeight="bold">
                              {/* <b style={{ color: "red" }}>* </b> */}
                              Previous Exam Year:
                            </Typography>
                          </Grid>
                          <Grid item size={{ sm: 6, xs: 12 }}>
                            <TextField
                              fullWidth
                              size="small"
                              // value={
                              //   stateDetails?.ex_yr_exam
                              //     ? stateDetails?.ex_yr_exam
                              //     : prevYear
                              // }
                              value={prevYear}
                              // disabled={stateDetails?.ex_yr_exam}
                              placeholder="Please enter Previour Exam Year"
                              onChange={(e) => setPrevYear(e.target.value)}
                            />
                          </Grid>
                        </Grid>
                      </Grid>{" "}
                      <Grid item size={{ xs: 12, md: 6 }}></Grid>
                    </>
                  )}
                </Grid>
                <Box sx={{ pt: 2, borderTop: "2px solid #ccc", mt: 2 }}>
                  <Typography fontSize="16px" fontWeight="bold" gutterBottom>
                    <b style={{ color: "red" }}>* </b>SUBJECT OFFERED:
                  </Typography>
                  <br />
                  <Grid
                    container
                    spacing={0}
                    style={{
                      flex: 1,
                      // backgroundColor: "red",
                      justifyContent: "space-between",
                      // justifyContent: "space-around",
                    }}
                  >
                    {/* MIL */}

                    <Grid item size={{ xs: 12, md: 3 }}>
                      <Typography align="center" fontWeight="bold">
                        MIL
                      </Typography>
                      <br />

                      {/* {["Hindu", "URD-URDU", "Bangla", "Maithli"].map(
                        (label) => (
                          <Box
                            key={label}
                            display="flex"
                            alignItems="center"
                            width="90%"
                            mb={0.5}
                          >
                            <Checkbox />
                            <TextField
                              variant="outlined"
                              size="small"
                              fullWidth
                              defaultValue={label}
                            />
                          </Box>
                        )
                      )} */}

                      <Box
                        key={
                          stateDetails?.sub1 === "MHND"
                            ? "Hindi"
                            : stateDetails?.sub1 === "MURD"
                            ? "URDU"
                            : stateDetails?.sub1 === "MMAI"
                            ? "Maithli"
                            : stateDetails?.sub1 === "MBNG"
                            ? "Bangla"
                            : "Other"
                        }
                        display="flex"
                        alignItems="center"
                        width="90%"
                        mb={0.5}
                      >
                        <Checkbox
                          checked={selectedSubjects?.includes("sub1")}
                          onChange={() => {
                            handleSelectedSubjects("sub1");
                          }}
                          disabled={
                            stateDetails?.o_reg &&
                            stateDetails?.o_reg?.split("-")[2] != "24"
                              ? false
                              : stateDetails?.mks1 === "ABS"
                              ? false
                              : stateDetails?.applycat === "C"
                              ? stateDetails?.res1 == "F"
                                ? false
                                : true
                              : getSingleSUbjectsList(stateDetails)
                              ? true
                              : isStudentFail_Absent()
                              ? stateDetails?.mks1 === "ABS" ||
                                stateDetails?.res1 == "F"
                                ? false
                                : stateDetails?.applycat == "B"
                                ? false
                                : true
                              : false
                          }
                        />
                        <TextField
                          variant="outlined"
                          size="small"
                          fullWidth
                          disabled
                          defaultValue={
                            stateDetails?.sub1 === "MHND"
                              ? "Hindi"
                              : stateDetails?.sub1 === "MURD"
                              ? "URDU"
                              : stateDetails?.sub1 === "MMAI"
                              ? "Maithli"
                              : stateDetails?.sub1 === "MBNG"
                              ? "Bangla"
                              : "Other"
                          }
                        />
                      </Box>
                    </Grid>

                    {/* SIL */}
                    <Grid item size={{ xs: 12, md: 3 }}>
                      <Typography align="center" fontWeight="bold">
                        SIL
                      </Typography>
                      <br />

                      <Box
                        key={
                          stateDetails?.sub2 === "SSNK"
                            ? "Sankrit"
                            : stateDetails?.sub2 === "SBHO"
                            ? "Bhojpuri"
                            : stateDetails?.sub2 === "SNLH"
                            ? "Hindi"
                            : stateDetails?.sub2 === "SARB"
                            ? "Arabic"
                            : "Persian"
                        }
                        display="flex"
                        alignItems="center"
                        width="90%"
                        mb={0.5}
                      >
                        <Checkbox
                          checked={selectedSubjects?.includes("sub2")}
                          onChange={() => {
                            handleSelectedSubjects("sub2");
                          }}
                          disabled={
                            stateDetails?.o_reg &&
                            stateDetails?.o_reg?.split("-")[2] != "24"
                              ? false
                              : stateDetails?.mks2 === "ABS"
                              ? false
                              : stateDetails?.applycat === "C"
                              ? stateDetails?.res2 == "F"
                                ? false
                                : true
                              : getSingleSUbjectsList(stateDetails)
                              ? true
                              : isStudentFail_Absent()
                              ? stateDetails?.mks2 === "ABS" ||
                                stateDetails?.res2 == "F"
                                ? false
                                : stateDetails?.applycat == "B"
                                ? false
                                : true
                              : false
                          }
                        />
                        <TextField
                          variant="outlined"
                          size="small"
                          fullWidth
                          disabled
                          defaultValue={
                            stateDetails?.sub2 === "SSNK"
                              ? "Sankrit"
                              : stateDetails?.sub2 === "SBHO"
                              ? "Bhojpuri"
                              : stateDetails?.sub2 === "SNLH"
                              ? "Hindi"
                              : stateDetails?.sub2 === "SARB"
                              ? "Arabic"
                              : "Persian"
                          }
                        />
                      </Box>
                    </Grid>

                    {/* COMPULSORY SUBJECTS */}
                    <Grid
                      item
                      size={{
                        xs: 12,
                        md: 3,
                        // borderTop: "2px solid #ccc",
                        // mt: 2,
                      }}
                    >
                      <Typography align="center" fontWeight="bold">
                        COMPULSORY SUBJECTS
                      </Typography>
                      <br />

                      {[
                        {
                          label: stateDetails.sub3,
                          names: "sub3",
                          disabled: "res3",
                          absCheck: "mks3",
                        },
                        {
                          label: stateDetails.sub4,
                          names: "sub4",
                          disabled: "res4",
                          absCheck: "mks4",
                        },
                        {
                          label: stateDetails.sub5,
                          names: "sub5",
                          disabled: "res5",
                          absCheck: "mks5",
                        },
                        {
                          label: stateDetails.sub7,
                          names: "sub7",
                          disabled: "res7",
                          absCheck: "mks7",
                        },
                      ].map(({ label, names, disabled, absCheck }) => (
                        <Box
                          key={SubjectCodes?.[label]}
                          display="flex"
                          alignItems="center"
                          width="90%"
                          mb={0.5}
                        >
                          <Checkbox
                            checked={selectedSubjects?.includes(names)}
                            onChange={() => {
                              handleSelectedSubjects(names);
                            }}
                            disabled={
                              stateDetails?.o_reg &&
                              stateDetails?.o_reg?.split("-")[2] != "24"
                                ? false
                                : stateDetails?.[absCheck] === "ABS"
                                ? false
                                : stateDetails?.applycat === "C"
                                ? stateDetails?.[disabled] == "F"
                                  ? false
                                  : true
                                : getSingleSUbjectsList(stateDetails)
                                ? SubjectCodes?.[label] == "English"
                                  ? false
                                  : true
                                : isStudentFail_Absent()
                                ? stateDetails?.[absCheck] === "ABS" ||
                                  stateDetails?.[disabled] == "F"
                                  ? false
                                  : stateDetails?.applycat == "B"
                                  ? false
                                  : true
                                : false
                            }
                          />
                          <TextField
                            variant="outlined"
                            size="small"
                            fullWidth
                            disabled
                            defaultValue={SubjectCodes?.[label]}
                          />
                        </Box>
                      ))}
                    </Grid>

                    {/* OPTIONAL SUBJECT */}
                    <Grid item size={{ xs: 12, md: 3 }}>
                      <Typography align="center" fontWeight="bold">
                        OPTIONAL SUBJECT
                      </Typography>
                      <br />
                      {/* <TextField
                        variant="outlined"
                        size="small"
                        fullWidth
                        defaultValue="NA-NOT APPLICABLE"
                      /> */}

                      <Box
                        key={stateDetails?.sub6}
                        display="flex"
                        alignItems="center"
                        width="90%"
                        mb={0.5}
                      >
                        <Checkbox
                          checked={selectedSubjects?.includes("sub6")}
                          onChange={() => {
                            handleSelectedSubjects("sub6");
                          }}
                          // disabled={!stateDetails?.sub6}
                          disabled={
                            stateDetails?.o_reg &&
                            stateDetails?.o_reg?.split("-")[2] != "24" &&
                            stateDetails?.sub6
                              ? false
                              : stateDetails?.mks6 === "ABS"
                              ? false
                              : stateDetails?.sub6
                              ? stateDetails?.applycat === "C"
                                ? stateDetails?.res6 == "F"
                                  ? false
                                  : true
                                : false
                              : getSingleSUbjectsList(stateDetails)
                              ? true
                              : isStudentFail_Absent()
                              ? stateDetails?.mks6 === "ABS" ||
                                stateDetails?.res6 == "F"
                                ? false
                                : stateDetails?.applycat == "B"
                                ? false
                                : true
                              : true
                          }
                        />
                        <TextField
                          variant="outlined"
                          size="small"
                          fullWidth
                          defaultValue={
                            stateDetails?.sub6 ? stateDetails?.sub6 : "NA"
                          }
                          // disabled={!stateDetails?.sub6}
                          disabled
                        />
                      </Box>
                      <Box
                        style={{
                          marginTop: "50px",
                        }}
                      >
                        <Typography align="center" fontWeight="bold">
                          VOCATIONAL SUBJECT
                        </Typography>
                        <br />
                        {/* <TextField
                        variant="outlined"
                        size="small"
                        fullWidth
                        defaultValue="NA-NOT APPLICABLE"
                      /> */}
                        <Box
                          key={stateDetails?.sub8}
                          display="flex"
                          alignItems="center"
                          width="90%"
                          mb={0.5}
                        >
                          <Checkbox
                            // disabled={!stateDetails?.sub8}
                            checked={selectedSubjects?.includes("sub8")}
                            onChange={() => {
                              handleSelectedSubjects("sub8");
                            }}
                            disabled={
                              stateDetails?.o_reg &&
                              stateDetails?.o_reg?.split("-")[2] != "24" &&
                              stateDetails?.sub8
                                ? false
                                : stateDetails?.mks8 === "ABS"
                                ? false
                                : stateDetails?.sub8
                                ? stateDetails?.applycat === "C"
                                  ? stateDetails?.res8 == "F"
                                    ? false
                                    : true
                                  : false
                                : getSingleSUbjectsList(stateDetails)
                                ? true
                                : isStudentFail_Absent()
                                ? stateDetails?.mks8 === "ABS" ||
                                  stateDetails?.res8 == "F"
                                  ? false
                                  : stateDetails?.applycat == "B"
                                  ? false
                                  : true
                                : true
                            }
                          />
                          <TextField
                            variant="outlined"
                            size="small"
                            fullWidth
                            defaultValue={
                              stateDetails?.sub8 ? stateDetails?.sub8 : "NA"
                            }
                            disabled={!stateDetails?.sub8}
                          />
                        </Box>
                      </Box>
                    </Grid>
                  </Grid>
                </Box>

                {/* Address Details */}
                <Divider sx={{ my: 3, borderTop: "2px solid #ccc", mt: 3 }} />
                <Typography
                  fontSize="16px"
                  marginBottom="16px"
                  fontWeight="bold"
                  gutterBottom
                >
                  <b style={{ color: "red" }}>* </b>ADDRESS DETAILS:
                </Typography>

                <Grid container spacing={2}>
                  <Grid item size={{ xs: 12, md: 6 }}>
                    <Grid container spacing={1}>
                      <Grid item size={{ sm: 6, xs: 12 }}>
                        <Typography variant="body2" fontWeight="bold">
                          <b style={{ color: "red" }}>* </b>Address:
                        </Typography>
                      </Grid>
                      <Grid item size={{ sm: 6, xs: 12 }}>
                        <TextField
                          size="small"
                          fullWidth
                          // defaultValue="GHORA CHOWK PARARIA"
                          // value={adderss}
                          value={adderss}
                          onChange={(e) => setAddress(e.target.value)}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item size={{ xs: 12, md: 6 }}>
                    <Grid container spacing={1}>
                      <Grid item size={{ sm: 6, xs: 12 }}>
                        <Typography variant="body2" fontWeight="bold">
                          <b style={{ color: "red" }}>* </b>District Name:
                        </Typography>
                      </Grid>
                      <Grid item size={{ sm: 6, xs: 12 }}>
                        {/* <TextField
                          size="small"
                          fullWidth
                          defaultValue="ARARIA"
                          value={district}
                          onChange={(e) => setDistrict(e.target.value)}
                        /> */}
                        <Select
                          // value={district}
                          value={district}
                          onChange={(e) => {
                            setDistrict(e.target.value);
                          }}
                          // width
                          fullWidth
                          // defaultValue="Special"
                          className="card-title"
                          sx={{
                            height: 36, // Adjust the height
                            "& .MuiSelect-select": {
                              padding: "8px", // Adjust inner padding
                              minHeight: "unset", // Override MUI's default min-height
                            },
                          }}
                        >
                          {districtLists.map((item) => {
                            return (
                              <MenuItem key={item?.value} value={item?.value}>
                                {item.label}
                              </MenuItem>
                            );
                          })}
                        </Select>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item size={{ xs: 12, md: 6 }}>
                    <Grid container spacing={1}>
                      <Grid item size={{ sm: 6, xs: 12 }}>
                        <Typography variant="body2" fontWeight="bold">
                          <b style={{ color: "red" }}>* </b>Town / City Name:
                        </Typography>
                      </Grid>
                      <Grid item size={{ sm: 6, xs: 12 }}>
                        <TextField
                          size="small"
                          fullWidth
                          // defaultValue="ARARIA"
                          value={townCity}
                          onChange={(e) => setTownCity(e.target.value)}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item size={{ xs: 12, md: 6 }}>
                    <Grid container spacing={1}>
                      <Grid item size={{ sm: 6, xs: 12 }}>
                        <Typography variant="body2" fontWeight="bold">
                          <b style={{ color: "red" }}>* </b>Pincode:
                        </Typography>
                      </Grid>
                      <Grid item size={{ sm: 6, xs: 12 }}>
                        <TextField
                          size="small"
                          fullWidth
                          defaultValue="854333"
                          value={Pincode}
                          onChange={(e) => setPinCode(e.target.value)}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Box>

              <Box sx={{ pt: 2, borderTop: "2px solid #ccc", mt: 2 }}>
                <Typography fontWeight="bold" gutterBottom>
                  <b style={{ color: "red" }}>* </b>PHOTO & SIGNATURE:
                </Typography>
                <Grid container spacing={2}>
                  {/* Photo Section */}
                  <Grid item size={{ xs: 12, md: 6 }}>
                    <Box
                      sx={{
                        padding: "8px",
                      }}
                    >
                      {isEdit ? (
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "10px",
                          }}
                        >
                          <img
                            src={
                              photo
                                ? photo
                                : `${baseURL}${
                                    stateDetails?.compartmentFormRequest_data?.photograph_path?.startsWith(
                                      "/"
                                    )
                                      ? stateDetails?.compartmentFormRequest_data?.photograph_path?.slice(
                                          1
                                        )
                                      : stateDetails
                                          ?.compartmentFormRequest_data
                                          ?.photograph_path
                                  }`
                            }
                            alt="Uploaded Photo"
                            style={{
                              width: "100px",
                              height: "100px",
                              objectFit: "cover",
                              borderRadius: "8px",
                            }}
                          />
                          <Button
                            variant="contained"
                            color="secondary"
                            size="small"
                            onClick={handleDeletePhoto}
                          >
                            Delete
                          </Button>
                        </div>
                      ) : (
                        <Typography
                          sx={{
                            color: "#999",
                            fontSize: "14px",
                            fontStyle: "italic",
                          }}
                        >
                          No photo uploaded
                        </Typography>
                      )}
                      <Input
                        type="file"
                        // inputProps={{ accept: "image/jpeg" }}
                        inputProps={{ accept: "image/jpeg, image/jpg" }}
                        onChange={handlePhotoChange}
                        sx={{ mt: 1, display: "block" }}
                        inputRef={fileInputRef}
                      />
                      <Button
                        variant="contained"
                        color={details?.photograph ? "success" : "error"}
                        sx={{ mt: 1, fontWeight: "bold" }}
                        size="small"
                        disabled={!photo}
                        onClick={() => handlePublichPhoto("photograph")}
                      >
                        {details?.photograph ? "Uploaded" : "Upload Photo"}
                      </Button>
                      {/* {details?.photograph && (
                        <Button
                          variant="contained"
                          color="primary"
                          sx={{ mt: 1, fontWeight: "bold" }}
                          style={{
                            marginLeft: "5px",
                          }}
                          size="small"
                          onClick={handleButtonClick}
                        >
                          {"Update"}
                        </Button>
                      )} */}
                    </Box>
                  </Grid>

                  {/* Signature Section */}
                  <Grid item size={{ xs: 12, md: 6 }}>
                    <Box
                      sx={{
                        padding: "8px",
                      }}
                    >
                      {isEdit ? (
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "10px",
                          }}
                        >
                          <img
                            src={signature}
                            alt="Uploaded Signature"
                            style={{
                              width: "100px",
                              height: "50px",
                              objectFit: "cover",
                              borderRadius: "8px",
                            }}
                          />
                          <Button
                            variant="contained"
                            color="secondary"
                            size="small"
                            onClick={handleDeleteSignature}
                          >
                            Delete
                          </Button>
                        </div>
                      ) : (
                        <Typography
                          sx={{
                            color: "#999",
                            fontSize: "14px",
                            fontStyle: "italic",
                          }}
                        >
                          No signature uploaded
                        </Typography>
                      )}
                      <Input
                        type="file"
                        // inputProps={{ accept: "image/jpeg" }}
                        inputProps={{ accept: "image/jpeg, image/jpg" }}
                        onChange={handleSignatureChange}
                        sx={{ mt: 1, display: "block" }}
                        inputRef={fileInputSignatureRef}
                      />
                      <Button
                        variant="contained"
                        // color="error"
                        color={details?.signature ? "success" : "error"}
                        sx={{ mt: 1, fontWeight: "bold" }}
                        size="small"
                        disabled={!signature}
                        onClick={() => handlePublichPhoto("signature")}
                      >
                        {details?.signature ? "Uploaded" : "Upload Signature"}
                      </Button>
                    </Box>
                  </Grid>
                </Grid>

                {/* Notes Section */}
                <Box sx={{ mt: 2 }}>
                  <Typography
                    variant="body2"
                    sx={{
                      fontSize: "12px",
                      fontWeight: "bold",
                    }}
                    className="card-title"
                  >
                    Note:{" "}
                    <b style={{ color: "red" }}>
                      Do not use any special character of image file name.
                    </b>
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{ fontSize: "12px" }}
                    className="card-title"
                  >
                    1. Upload recent color photograph only in JPG/JPEG format,
                    size of Photograph should be between 50 kb to 100 kb &
                    dimensions are 35 mm * 30 mm. Background should be plain
                    white or light green.
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{ fontSize: "12px" }}
                    className="card-title"
                  >
                    2. Upload signature only in JPG/JPEG format, size of
                    Signature should be between 5 kb to 20 kb. dimensions are
                    3.5 cm * 1 cm.
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{ fontSize: "12px" }}
                    className="card-title"
                  >
                    3.{" "}
                    <b style={{ color: "red" }}>
                      Please upload photograph in proper size and shape (Head
                      size/Face size: 20mm X 25 mm approx 60% to 70%).
                    </b>
                  </Typography>
                </Box>
              </Box>
              <Box
                sx={{
                  pt: 2,
                  textAlign: "center",
                  borderTop: "2px solid #ccc",
                  mt: 2,
                }}
              >
                <Grid container alignItems="center" spacing={1}>
                  {/* Checkbox Section */}
                  <Grid item>
                    <Checkbox
                      checked={checked}
                      onChange={handleCheckboxChange}
                      color="primary"
                      disabled={
                        details?.signature && details?.photograph ? false : true
                      }
                    />
                  </Grid>

                  {/* Confirmation Text */}
                  <Grid item>
                    <Typography
                      variant="body2"
                      sx={{
                        color: "red",
                        fontSize: "14px",
                        textAlign: "justify",
                      }}
                      className="card-title"
                    >
                      I confirm that the information given in this form is true,
                      complete, and accurate to the best of my knowledge and
                      belief. In case any of the above information is found to
                      be false, untrue, or misleading, it may lead to the
                      cancellation of my candidature, and B.S.E.B. can take
                      legal action against me.
                    </Typography>
                  </Grid>
                </Grid>

                {/* Apply Button */}
                <Box sx={{ mt: 2 }}>
                  <Button
                    variant="contained"
                    color="success"
                    onClick={handleApplyClick}
                    sx={{
                      px: 4,
                    }}
                  >
                    Edit
                  </Button>
                </Box>
              </Box>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      <Backdrop open={loader} style={{ zIndex: 1300, color: "#fff" }}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </Box>
  );
}

export default EditPersonlDetails;
